<template>
  <div class="collection-container">
    <Header title="我的收藏" />
    <div class="collection-inner">
      <div class="department">
        <span @click="changeSelect('departmentId')" :class="{ active: !select.departmentId }">全部部门</span>
        <span v-for="{ departmentId, departmentName } in departmentList" :key="departmentId"
          @click="changeSelect('departmentId', departmentId)" :class="{ active: departmentId === select.departmentId }">
          {{ departmentName }}</span>
      </div>
      <section>
        <div class="category" data-title="所属分类">
          <div>
            <span @click="changeSelect('categoryId')" :class="{ active: !select.categoryId }">全部</span>
            <span v-for="{ categoryId, categoryName } in categoryList" :key="categoryId"
              @click="changeSelect('categoryId', categoryId)" :class="{ active: categoryId === select.categoryId }">
              {{ categoryName }}</span>
          </div>
        </div>
        <div class="divider"></div>
        <div class="result">
          <div id="service" v-for="item in collectionList" :key="item.employId"
            @click="$router.push(`guide?employId=${item.employId}`)">
            <p>
              <i :class="`el-icon-${item.icon}`"></i>
              <span>{{ item.employName }}</span>
              <el-tooltip placement="left" content="取消收藏" effect="light">
                <img src="../../assets/星星.png" alt="" width="24" @click.stop="collectService(item.employId)">
              </el-tooltip>
            </p>
            <div>
              <span>{{ item.departmentName }}</span>
              <span>{{ ['线下办理', '线上办理', ' 线上线下结合'][item.handleWay - 1] }}</span>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Footer />
  </div>
</template>

<script>
import * as api from './api'
export default {
  name: 'Collection',
  components: {
    Header: () => import('../../components/Header'),
    Footer: () => import('../../components/Footer')
  },
  data() {
    return {
      departmentList: [],
      categoryList: [],
      select: {},
      collectionList: []
    }
  },
  async created() {
    const { data: { departmentList } } = await api.getDepartmentList()
    this.departmentList = departmentList
    const { data: { categoryList } } = await api.getCategoryList()
    this.categoryList = categoryList
    this.getCollectionList()
  },
  methods: {
    async getCollectionList() {
      const { data: { employList } } = await api.getCollectionList(this.select)
      this.collectionList = employList
    },
    changeSelect(type, id) {
      this.$set(this.select, type, id)
      this.getCollectionList()
    },
    async collectService(employId) {
      await api.collectService(employId)
      this.$message.success('已取消收藏')
      this.getCollectionList()
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-container {
  background: #F9FBFC;

  .collection-inner {
    min-height: 100vh;
    width: var(--inner-width);
    margin: auto;
    padding: 100px;
    display: flex;
    gap: 40px;

    .department {
      width: 250px;

      &::before {
        content: '所属部门';
        display: block;
        height: 60px;
        background: $mainColor;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        line-height: 60px;
        text-align: center;
      }

      span {
        display: block;
        height: 50px;
        background: #eee;
        color: #333;
        font-size: 14px;
        line-height: 50px;
        cursor: pointer;
        padding-left: 20px;
        border-bottom: 1px solid #fff;
        position: relative;

        &::before {
          content: '';
          width: calc(100% - 4px);
          height: 100%;
          position: absolute;
          right: 0;
          background: #fff;
          opacity: 0;
        }

        &.active {
          background: linear-gradient(to right, $mainColor, #fff);
          color: #fff;

          &::before {
            opacity: .4;
          }
        }
      }
    }

    section {
      flex: 1;

      .role {
        margin-bottom: 30px;
      }

      .role,
      .category {
        display: flex;
        gap: 20px;

        &::before {
          content: attr(data-title);
          color: #333;
          transform: translateY(8px);
          font-size: 18px;
        }

        div {
          flex: 1;
          display: flex;
          gap: 20px;
          flex-wrap: wrap;

          span {
            background: #eee;
            padding: 8px 20px;
            color: #888;
            border-radius: 17px;
            cursor: pointer;
            transition: 300ms ease-in-out;

            &.active {
              background: $mainColor;
              color: #fff;
            }
          }
        }
      }

      .divider {
        height: 1px;
        background: #d9d9d9;
        margin: 40px 0;
      }

      .result {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 25px;
      }
    }
  }
}
</style>